import { render } from "./PeajesPage.vue?vue&type=template&id=0cd15a92"
import script from "./PeajesPage.vue?vue&type=script&lang=js"
export * from "./PeajesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__